import { render, staticRenderFns } from "./CoachFormDialog.vue?vue&type=template&id=9b8a839c"
import script from "./CoachFormDialog.vue?vue&type=script&lang=js"
export * from "./CoachFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports